export enum Experiment {
  EditorOOI = 'specs.loyalty.EditorOOIMyRewards',
  FetchCustomRewardsFromSpi = 'specs.loyalty.FetchCustomRewardsFromSpi',
  SettingsBPIndicators = 'specs.loyalty.MyRewardsSettingsBPIndicators',
}
